const validate = values => {
  const errors = {};
  if (!values.equ_nome) {
    errors.equ_nome = 'Campo Obrigatório';
  }

  return errors;
};

export default validate;






// WEBPACK FOOTER //
// ./src/service/validate_equipe.js